import { bffParser } from './helpers/bff-parser'
import { composeSession } from './helpers/compose-session'
import { entityDetailParser } from './helpers/entity-detail-parser'
import { withLegacyStoneAccount } from './helpers/legacy-stone-account'
import { type BffData, fetchBff } from './services/fetch-bff'
import { type EntityData, fetchEntityDetail } from './services/fetch-entity-detail'
import { getExMachinaSource } from './services/get-ex-machina-source'
import { type Entity, type OptIns, type Subject } from './types'

interface Source<T = unknown> {
  fetcher: (optIns: OptIns[]) => Promise<T>
  parser: (data: T, activeGlobalId?: string) => { subject: Subject<OptIns>; entity: Entity<OptIns> }
}

const bffSource: Source<BffData> = {
  fetcher: fetchBff,
  parser: bffParser
}

const entitySource: Source<EntityData> = {
  fetcher: fetchEntityDetail,
  parser: entityDetailParser
}

const sourceMap = {
  bff: bffSource,
  entity: entitySource
}

const fetchLegacySession = async (activeGlobalId?: string) => {
  const source = await getExMachinaSource()
  const { fetcher, parser } = sourceMap[source]

  /**
   * @disclaimer conditional fetching are currently not supported, so we passing all flags statically
   */
  const data = await fetcher(['acquirer', 'banking', 'stone_account', 'stone_account_kyc', 'stone_account_resources'])

  return withLegacyStoneAccount(parser(data as BffData & EntityData, activeGlobalId))
}

export const exMachina = async () => {
  return composeSession(fetchLegacySession)
}
